import createBusinessRepository from '@/repository/business.ts'
import createDirectBusinessRepository from '@/repository/direct-sign/business.ts'
import createDocumentRepository from '@/repository/document.ts'
import createFeaturebaseRepository from '@/repository/featurebase.ts'
import createDirectDocumentRepository from '@/repository/direct-sign/document.ts'
import createHubspotRepository from '@/repository/hubspot.ts'
import createIdentificationRepository from '@/repository/identification.ts'
import createDirectIdentificationRepository from '@/repository/direct-sign/identification.ts'
import createPaymentRepository from '@/repository/payment.ts'
import createSealRepository from '@/repository/seal.ts'
import createSearchRepository from '@/repository/search.ts'
import createSrRepository from '@/repository/signatureRequest.ts'
import createDirectSrRepository from '@/repository/direct-sign/signatureRequest.ts'
import createSigningRepository from '@/repository/signing.ts'
import createDirectSigningRepository from '@/repository/direct-sign/signing.ts'
import createSsoRepository from '@/repository/sso.ts'
import createTanRepository from '@/repository/tan.ts'
import createDirectTanRepository from '@/repository/direct-sign/tan.ts'
import createUserRepository from '@/repository/user.ts'
import createDirectUserRepository from '@/repository/direct-sign/user.ts'
import createSystemRepository from '@/repository/system.ts'
import createVisualSignatureRepository from '@/repository/visualSignature.ts'
import createDirectVisualSignatureRepository from '@/repository/direct-sign/visualSignature.ts'
import createActivityRepository from '@/repository/activity.ts'
import createGroupsRepository from '@/repository/groups.ts'
import createMabRepository from '@/repository/mab.ts'
import createDirectMabRepository from '@/repository/direct-sign/mab.ts'

export default function useApi() {
  const { $api } = useNuxtApp()

  return {
    businessRepository: createBusinessRepository($api),
    directBusinessRepository: createDirectBusinessRepository($api),
    documentRepository: createDocumentRepository($api),
    featurebaseRepository: createFeaturebaseRepository($api),
    directDocumentRepository: createDirectDocumentRepository($api),
    hubspotRepository: createHubspotRepository($fetch),
    identificationRepository: createIdentificationRepository($api),
    directIdentificationRepository: createDirectIdentificationRepository($api),
    paymentRepository: createPaymentRepository($api),
    sealRepository: createSealRepository($api),
    searchRepository: createSearchRepository($api),
    srRepository: createSrRepository($api),
    directSrRepository: createDirectSrRepository($api),
    signingRepository: createSigningRepository($api),
    directSigningRepository: createDirectSigningRepository($api),
    ssoRepository: createSsoRepository($api),
    tanRepository: createTanRepository($api),
    directTanRepository: createDirectTanRepository($api),
    userRepository: createUserRepository($api),
    directUserRepository: createDirectUserRepository($api),
    systemRepository: createSystemRepository($api),
    visualSignatureRepository: createVisualSignatureRepository($api),
    directVisualSignatureRepository: createDirectVisualSignatureRepository($api),
    activityRepository: createActivityRepository($api),
    groupsRepository: createGroupsRepository($api),
    mabRepository: createMabRepository($api),
    directMabRepository: createDirectMabRepository($api),
  }
}
